import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { Rimediazione } from "../types"
import { API_URL } from "../constants"

export function useRimediazioniList(params: Record<string, string> = {}) {
  return useList<Rimediazione>(`${API_URL}/rimediazioni`, {
    query: params,
  })
}

export function useRimediazione(id: number | undefined | string) {
  return useDetail<Rimediazione>(`${API_URL}/rimediazioni`, id?.toString())
}

export function useRimediazioneCreate() {
  return useCreate<Rimediazione>(`${API_URL}/rimediazioni`)
}

export function useRimediazioneUpdate() {
  return useUpdate<Rimediazione>(`${API_URL}/rimediazioni`)
}

export function useRimediazioneDelete() {
  return useDelete<Rimediazione>(`${API_URL}/rimediazioni`)
}